import DashboardIcon from '../component/atoms/icons/DashboardIcon';
import OrderIcon from '../component/atoms/icons/OrderIcon';
import PromoIcon from '../component/atoms/icons/PromoIcon';
import ServerIcon from '../component/atoms/icons/ServerIcon';
import PaymentIcon from '../component/atoms/icons/PaymentIcon';
import ServiceTypeIcon from '../component/atoms/icons/ServiceTypeIcon';
import ReportsIcon from '../component/atoms/icons/ReportsIcon';
import QuoteIcon from '../component/atoms/icons/QuoteIcon';
import LeadIcon from '../component/atoms/icons/LeadIcon';
import BlogIcon from '../component/atoms/icons/BlogIcon';

export interface SidebarItem {
  title: string;
  path: string;
  checkSidebar: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  children?: SidebarItem[];
  disabled?: boolean;
  badge?: string | number;
  description?: string;
}

export const sidebarConfig: SidebarItem[] = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    checkSidebar: 'dashboard',
    icon: DashboardIcon,
  },
  {
    title: 'Distributor',
    path: '/distributor',
    checkSidebar: 'distributor',
    icon: OrderIcon,
  },
  {
    title: 'Promo',
    path: '/promo',
    checkSidebar: 'promo',
    icon: PromoIcon,
  },
  {
    title: 'Server',
    path: '/server',
    checkSidebar: 'server',
    icon: ServerIcon,
  },
  {
    title: 'Server Monitoring',
    path: '/server-monitoring',
    checkSidebar: 'server-monitoring',
    icon: ServerIcon,
  },
  {
    title: 'Payment',
    path: '/payment',
    checkSidebar: 'payment',
    icon: PaymentIcon,
  },
  {
    title: 'Service Type',
    path: '/service-type',
    checkSidebar: 'service-type',
    icon: ServiceTypeIcon,
  },
  {
    title: 'Tickets',
    path: '/tickets',
    checkSidebar: 'tickets',
    icon: ReportsIcon,
  },
  {
    title: 'Quote',
    path: '/quote',
    checkSidebar: 'quote',
    icon: QuoteIcon,
  },
  {
    title: 'Lead',
    path: '/lead',
    checkSidebar: 'lead',
    icon: LeadIcon,
  },
  {
    title: 'Blog',
    path: '/blog',
    checkSidebar: 'blog',
    icon: BlogIcon,
  },
  {
    title: 'New Version',
    path: '/new-versions',
    checkSidebar: 'new-versions',
    icon: PromoIcon,
  },
  {
    title: 'AppUpdate',
    path: '/app-updates',
    checkSidebar: 'app-updates',
    icon: PromoIcon,
  },
];

// Utility functions for sidebar management
export const findSidebarItemByPath = (path: string, items: SidebarItem[] = sidebarConfig): SidebarItem | null => {
  for (const item of items) {
    if (item.path === path) {
      return item;
    }
    if (item.children) {
      const found = findSidebarItemByPath(path, item.children);
      if (found) return found;
    }
  }
  return null;
};

export const getActiveSidebarItem = (currentPath: string, items: SidebarItem[] = sidebarConfig): SidebarItem | null => {
  // First try exact match
  const exactMatch = findSidebarItemByPath(currentPath, items);
  if (exactMatch) return exactMatch;

  // Then try prefix match
  for (const item of items) {
    if (currentPath.startsWith(item.path + '/')) {
      return item;
    }
    if (item.children) {
      const found = getActiveSidebarItem(currentPath, item.children);
      if (found) return found;
    }
  }
  return null;
};

export const getAllSidebarPaths = (items: SidebarItem[] = sidebarConfig): string[] => {
  const paths: string[] = [];
  
  const traverse = (items: SidebarItem[]) => {
    for (const item of items) {
      paths.push(item.path);
      if (item.children) {
        traverse(item.children);
      }
    }
  };
  
  traverse(items);
  return paths;
};

export const isSidebarPathActive = (path: string, currentPath: string): boolean => {
  return currentPath === path || currentPath.startsWith(path + '/');
};
